import React from 'react';
import { useTranslation } from 'react-i18next';
import { Form } from '@thinknet-gmbh/platform-common-ui';

import { BooleanSelectInput } from 'src/pages/employee/components/boolean-select-input';

import { StyledButton, MiniJobDocumentContainer } from './mini-job-document.styles';

import { IQuestionnaireFieldProps } from '../form-item-field/form-item-field.intrrface';

const MiniJobDocument = ({ label }: IQuestionnaireFieldProps) => {
  const { t } = useTranslation('employee');

  return (
    <MiniJobDocumentContainer>
      <Form.Item
        className={'form-item-select'}
        rules={[{ required: true, message: t('customers:error.fieldIsRequired') }]}
        name={['finishInformation', 'exemptFromPensionFund']}
        label={t(`employee:questionnaire.finishInformation.exemptFromPensionFund`)}
      >
        <BooleanSelectInput t={t} />
      </Form.Item>
      <Form.Item noStyle shouldUpdate>
        {({ getFieldValue, setFieldsValue }) => {
          const fieldIsRequired = getFieldValue(['finishInformation', 'exemptFromPensionFund']);
          const miniJobDocumentClick =
            getFieldValue(['finishInformation', 'miniJobDocumentClick']) || 0;

          return (
            fieldIsRequired && (
              <Form.Item
                name={['finishInformation', 'miniJobDocumentClick']}
                label={''}
                rules={[
                  {
                    required: fieldIsRequired,
                    message: t('employee:questionnaire.validation.fileDownload'),
                  },
                ]}
              >
                <StyledButton
                  onClick={() => {
                    setFieldsValue({
                      finishInformation: {
                        miniJobDocumentClick: miniJobDocumentClick + 1,
                      },
                    });
                  }}
                >
                  {label}
                </StyledButton>
              </Form.Item>
            )
          );
        }}
      </Form.Item>
    </MiniJobDocumentContainer>
  );
};

export default MiniJobDocument;
